import React, { useEffect, useState } from "react";
import { BASE_URL, USER_URL } from "../../constant/api";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AdminEditBanner() {
  const { bannerId } = useParams();
    const [banner, setBanner] = useState({});
    const [products, setProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
  
    // Fetch banner details and products
      useEffect(() => {
        const fetchBannerDetails = async () => {
          try {
            const response = await USER_URL.get(`/products/seller/banners/${bannerId}/`);
            const data = response.data.Data.banner;
            const pdata = response.data.Data.products;
            console.log(response.data.Data.products);
            
            setBanner({
              ...data,
              banner_image: data.banner ? `${BASE_URL}${data.banner}` : null,
              banner_image_preview: data.banner ? `${BASE_URL}${data.banner}` : null,
            });
  
            // Transform the product data to include product_banner_image
            const transformedProducts = pdata.map((product) => ({
              product: product.product || product.id,
              product_banner_image: product.product_banner_image
                ? `${BASE_URL}${product.product_banner_image}`
                : null,
            }));
            
  
            setSelectedProducts(transformedProducts);
          } catch (error) {
            console.error("Error fetching banner details:", error.message || error);
            toast.error("Failed to fetch banner details!");
          }
        };
  
        const fetchProducts = async () => {
          try {
            const response = await USER_URL.get(`/products/seller/`);
            setProducts(response.data.Data || []);
          } catch (error) {
            console.error("Error fetching products:", error.message || error);
            toast.error("Failed to fetch products!");
          }
        };
  
        fetchBannerDetails();
        fetchProducts();
      }, [bannerId]);
  
    // Handle changes to the banner form
    const handleBannerChange = (e) => {
      const { name, value, files } = e.target;
  
      if (files?.length > 0) {
        const file = files[0];
        setBanner((prev) => ({
          ...prev,
          banner_image: file,
          banner_image_preview: URL.createObjectURL(file),
        }));
      } else {
        setBanner((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    };
  
    // Handle product selection
    const handleProductSelect = (productId) => {
      setSelectedProducts((prev) => {
        const isProductSelected = prev.some((p) => p.product === productId);
    
        // If the product is already selected, remove it
        if (isProductSelected) {
          return prev.filter((p) => p.product !== productId);
        } else {
          // If the product is not selected, add it with a null product_banner_image
          return [
            ...prev,
            {
              product: productId,
              product_banner_image: null,
            },
          ];
        }
      });
    };
  
    // Handle product image change
    const handleProductImageChange = (e, productId) => {
      const file = e.target.files[0];
      if (file) {
        setSelectedProducts((prev) => {
          // Check if the product already exists in the selectedProducts array
          const isProductSelected = prev.some((p) => p.product === productId);
    
          // If the product exists, update its product_banner_image
          if (isProductSelected) {
            return prev.map((p) =>
              p.product === productId ? { ...p, product_banner_image: file } : p
            );
          } else {
            // If the product doesn't exist, add it to the selectedProducts array
            return [
              ...prev,
              {
                product: productId,
                product_banner_image: file,
              },
            ];
          }
        });
      }
    };
  
    // Handle form submission
   // Handle form submission
   const handleSubmit = async () => {
    if (selectedProducts.length === 0) {
      toast.warn("Please select at least one product!");
      return;
    }
  
    setIsSubmitting(true);
    const formData = new FormData();
  
    // Append banner data
    formData.append("title", banner.title);
    if (banner.banner_image instanceof File) {
      formData.append("banner", banner.banner_image);
    } else if (banner.banner_image) {
      formData.append("banner_url", banner.banner_image);
    }
    formData.append("start_date", banner.start_date);
    formData.append("end_date", banner.end_date);
  
    // Append product data
    for (let i = 0; i < selectedProducts.length; i++) {
      const p = selectedProducts[i];
      formData.append(`banner_products[${i}]product`, p.product);
  
      // Handle product banner image
      if (p.product_banner_image instanceof File) {
        // New image (file)
        formData.append(`banner_products[${i}]product_banner_image`, p.product_banner_image);
      } else if (p.product_banner_image) {
        // Existing image (URL) - Fetch it as a file
        try {
          const response = await fetch(p.product_banner_image);
          const blob = await response.blob();
          const file = new File([blob], `product_image_${p.product}.jpg`, { type: blob.type });
          formData.append(`banner_products[${i}]product_banner_image`, file);
        } catch (error) {
          console.error("Error fetching existing product image:", error);
          toast.error("Failed to process existing product image!");
        }
      }
    }
  
    console.log("Form Data:", formData);
  
    try {
      await USER_URL.put(
        `/products/seller/banners/${bannerId}/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      toast.success("Banner updated successfully!");
    } catch (error) {
      console.error("Error updating banner:", error.response?.data || error.message);
      toast.error(
        error.response?.data?.message || "Failed to update banner. Please try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };
  
  // Render product image
  const renderProductImage = (product) => {
    const selectedProduct = selectedProducts.find((p) => p.product === product.id);
  
    if (!selectedProduct) {
      return (
        <div className="w-28 h-20 flex items-center justify-center border border-gray-300 rounded bg-gray-100">
          <span className="text-xs text-gray-500">No Image</span>
        </div>
      );
    }
  
    // Determine the image URL
    const imageUrl =
      selectedProduct.product_banner_image instanceof File
        ? URL.createObjectURL(selectedProduct.product_banner_image) // New image (file)
        : selectedProduct.product_banner_image; // Existing image (URL)
  
    return imageUrl ? (
      <img
        src={imageUrl}
        alt={product.name}
        className="w-28 h-20 object-cover rounded shadow-md"
      />
    ) : (
      <div className="w-28 h-20 flex items-center justify-center border border-gray-300 rounded bg-gray-100">
        <span className="text-xs text-gray-500">No Image</span>
      </div>
    );
  };
  
    return (
      <div>
        <ToastContainer position="top-center" autoClose={3000} />
        <div className="border-2 rounded-lg shadow-lg bg-gray-50 mt-10 p-6">
          <div className="flex justify-end text-center">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center text-green-600 hover:text-green-700 font-medium text-sm focus:outline-none"
            >
              <span>&lt; Back to Banner List</span>
            </button>
          </div>
          <h2 className="text-green-700 text-3xl font-bold text-center mb-6">Edit Banner</h2>
  
          {/* Banner Image Section */}
          <div className="flex flex-col gap-6 mb-6 w-full sm:flex-row sm:gap-8 sm:mb-8">
            <div className="w-full sm:w-1/2">
              <label className="text-gray-700 font-medium mb-2 block">Banner Image</label>
              <div className="border rounded-md">
                {banner.banner_image_preview ? (
                  <div className="relative">
                    <img
                      src={banner.banner_image_preview}
                      alt="Banner Preview"
                      className="w-full h-44 object-cover rounded-md mb-4"
                    />
                    {/* <button
                      type="button"
                      className="absolute top-2 right-2 bg-red-500 text-white rounded-full px-2 py-1 text-xs"
                      onClick={() =>
                        setBanner((prev) => ({
                          ...prev,
                          banner_image: null,
                          banner_image_preview: null,
                        }))
                      }
                    >
                      Remove
                    </button> */}
                  </div>
                ) : (
                  <div className="w-full h-40 bg-gray-100 flex items-center justify-center rounded-md text-gray-500 mb-4">
                    No Image Selected
                  </div>
                )}
                <input
                  type="file"
                  accept="image/*"
                  name="banner_image"
                  onChange={handleBannerChange}
                  className="mb-3 ml-3 text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
              </div>
            </div>
  
            {/* Banner Details Section */}
            <div className="w-full sm:w-1/2">
              <div>
                <label className="text-gray-700 font-medium mb-2 block">Banner Name</label>
                <input
                  type="text"
                  name="title"
                  value={banner.title || ""}
                  onChange={handleBannerChange}
                  className="w-full border p-2 rounded mb-3"
                  placeholder="Enter banner name"
                />
              </div>
  
              <div>
                <label className="text-gray-700 font-medium mb-2 block">Start Date</label>
                <input
                  type="date"
                  name="start_date"
                  value={banner.start_date || ""}
                  onChange={handleBannerChange}
                  className="w-full border p-2 rounded mb-3"
                />
              </div>
  
              <div>
                <label className="text-gray-700 font-medium mb-2 block">End Date</label>
                <input
                  type="date"
                  name="end_date"
                  value={banner.end_date || ""}
                  onChange={handleBannerChange}
                  className="w-full border p-2 rounded"
                />
              </div>
  
              <div>
                <button
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                  className="w-full mt-6 text-lg py-2 rounded bg-green-600 hover:bg-green-700 text-white font-semibold disabled:bg-gray-400"
                >
                  {isSubmitting ? "Submitting..." : "Update Banner"}
                </button>
              </div>
            </div>
          </div>
        </div>
  
        {/* Products Table */}
        <div className="mt-6">
          <h2 className="text-xl font-bold mb-4">Products</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-center">
              <thead>
                <tr>
                  <th className="py-2 px-2 text-green-500 text-md font-bold">Item No</th>
                  <th className="py-2 px-2 text-green-500 text-md font-bold">Product Code</th>
                  <th className="py-2 px-2 text-green-500 text-md font-bold">Product Name</th>
                  <th className="py-2 px-2 text-green-500 text-md font-bold">Stock</th>
                  <th className="py-2 px-2 text-green-500 text-md font-bold">Price</th>
                 
                </tr>
              </thead>
              <tbody>
                {products.map((product, index) => (
                  <tr key={product.id}>
                    <td className="py-2 px-2">
                      <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                        {index + 1}
                      </div>
                    </td>
  
                    <td className="py-2 px-2">
                      <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                        {product.product_code}
                      </div>
                    </td>
  
                    <td className="py-2 px-2">
                      <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                        {product.name}
                      </div>
                    </td>
  
                    <td className="py-2 px-2">
                      <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                        {product.stock}
                      </div>
                    </td>
  
                    <td className="py-2 px-2">
                      <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                        {product.price}
                      </div>
                    </td>
  
                    <td className="py-2 px-2">
                      <div className="flex-1 flex items-center">
                        <input
                          type="file"
                          accept="image/*"
                          id={`upload-input-${product.id}`}
                          onChange={(e) => handleProductImageChange(e, product.id)}
                          className="hidden"
                        />
                        <label
                          htmlFor={`upload-input-${product.id}`}
                          className="flex-1 flex items-center justify-center px-2 py-2 text-xs sm:text-sm font-medium text-blue-600 hover:text-white border border-blue-600 rounded-lg shadow-md hover:bg-blue-700 hover:border-blue-700 transition text-center cursor-pointer"
                        >
                          Upload
                        </label>
                      </div>
                    </td>
  
  
                    <td className="py-2 px-2">
                      <div className="flex-1 flex items-center justify-center rounded-lg">
                        {renderProductImage(product)}
                      </div>
                    </td>
  
                    <td className="py-2 px-2">
                      <div className="flex-1 flex items-center justify-center">
                        <button
                          onClick={() => handleProductSelect(product.id)}
                          className={`flex md:w-[130px] items-center justify-center py-2 text-xs sm:text-sm font-medium rounded-lg shadow-md ${selectedProducts.some((p) => p.product === product.id)
                              ? "text-red-600 hover:text-white border border-red-600 rounded-lg shadow-md hover:bg-red-700 hover:border-red-700 transition text-center"
                              : "text-green-600 hover:text-white border border-green-600 rounded-lg shadow-md hover:bg-green-700 hover:border-green-700 transition text-center"
                            }`}
                        >
                          {selectedProducts.some((p) => p.product === product.id) ? "Remove" : "Add to Banner"}
                        </button>
  
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }

export default AdminEditBanner